import MultiTagField from './multi-tag-field';
export default MultiTagField;
